import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ParamMap } from '@angular/router';
import { IRequestFactFindService } from './request-fact-find.tokens';

@Injectable({ providedIn: 'root' })
export class RequestFactFindDefaultService implements IRequestFactFindService {
  requestFrom: string[] = [];
  requested$ = new Subject<void>();

  async requestFactFind(paramMap: ParamMap, journal: any): Promise<void> {
    return;
  }
}
